import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import Form from "components/forms/form";
import TextareaInput from "components/forms/inputs/textarea";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import { faSave } from "components/icon-library";
import { FormValues } from "lib/form";
import { showGenericError, showGenericSuccess } from "lib/notification";
import { PrivacyPolicyModel } from "models/privacy-policy";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { adminDoPatchPrivacyPolicy } from "services/admin/privacy-policy";
import * as yup from "yup";

interface PrivacyPolicyFormProps {
  privacyPolicy: PrivacyPolicyModel;
}

const PrivacyPolicyForm: FunctionComponent<PrivacyPolicyFormProps> = ({
  privacyPolicy,
}) => {
  const schema = yup
    .object({
      text: yup.object().validateLocaleString(),
    })
    .required();

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      text: privacyPolicy.text,
    },
  });

  const buttons: FormButtonInterface[] = [
    { text: "Tallenna", submit: true, postIcon: faSave },
  ];

  const onSubmit = async (values: FormValues) => {
    try {
      const { text } = values as any;
      await adminDoPatchPrivacyPolicy(text);
      showGenericSuccess();
    } catch (err) {
      showGenericError();
    }
  };

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <Grid>
        <Row>
          <Col>
            <TextareaInput
              name="text"
              label="Tietosuojaseloste"
              translations
              height={30}
            />
          </Col>
        </Row>
        <FormButtons buttons={buttons} />
      </Grid>
    </Form>
  );
};

export default PrivacyPolicyForm;
